import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ObjectUtilitiesService {
  constructor() {}

  /**
   * returns true if given parameter is object
   * @param o any
   * @returns boolean
   */
  public isObject(o: any): boolean {
    return o !== null && typeof o === 'object' && !Array.isArray(o);
  }

  /**
   * loops through question json object and trims spaces from values
   * @param obj object
   * @returns object
   */
  public trimObjectValues<T>(obj: any): any {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (this.isObject(obj[key])) {
          obj[key] = this.trimObjectValues(obj[key]);
        } else if (Array.isArray(obj[key])) {
          const trimmedArray = obj[key].map((e: any) => {
            return this.trimObjectValues(e);
          });
          obj[key] = trimmedArray;
        } else if (typeof obj[key] === 'string') {
          const objValue: string = obj[key]
            ? obj[key].toString().trim()
            : obj[key];
          obj[key] = objValue;
        }
      }
    }
    return obj;
  }
}
